import axios, { AxiosResponse } from 'axios';
import { QueryKey } from 'react-query';
import { AxiosArgs, ThenArgs, League } from './types';
import { baseUrl } from './config';

// get leagues
export type getLeaguesResponse = Promise<AxiosArgs<ThenArgs<AxiosResponse<League[]>>>>;

export type getLeaguesType = (key: QueryKey) => getLeaguesResponse;

export const getLeagues: any = (key:any) => {
  const path = `${baseUrl}/api/leagues`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const getLeaguesHistory: any = () => {
  const path = `${baseUrl}/api/leagues/history`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data);
};
